import {
  BrandAssets,
  BrandConfig,
  BrandLinks,
  BrandTexts,
  BrandWebsiteLink,
} from './brand.interface';

type PartialBrandLinks = Partial<Omit<BrandLinks, 'website'>> & {
  website?: BrandWebsiteLink;
};

type BrandConfigInput = Omit<BrandConfig, 'links' | 'assets'> & {
  links?: PartialBrandLinks;
  assets?: Partial<BrandAssets>;
};

const defaultWebsite: BrandWebsiteLink = {
  label: '',
  url: '',
};

const defaultLinks: BrandLinks = {
  website: defaultWebsite,
  apiDocsUrl: '',
  termsUrl: '',
  iosAppUrl: '',
  androidAppUrl: '',
};

const defaultAssets: BrandAssets = {
  logoUrl: 'assets/brands/telepagos/img/logo.png',
  footerLogoUrl: 'assets/brands/telepagos/svg/isologo-blanco.svg',
  faviconUrl: 'assets/brands/telepagos/img/favicon-32x32.png',
  favicon16Url: 'assets/brands/telepagos/img/favicon-16x16.png',
  favicon32Url: 'assets/brands/telepagos/img/favicon-32x32.png',
};

export function createDefaultBrandTexts(brandName: string): BrandTexts {
  return {
    signupDownloadMessage: `Descarg\u00e1 ${brandName} y abr\u00ed tu cuenta.`,
    qrScanAppMessage: `Ingres\u00e1 a la App de ${brandName} en tu dispositivo y escane\u00e1 el siguiente QR.`,
    devicesHelpInstall: `Para agregar un nuevo dispositivo ten\u00e9s que instalar ${brandName} en el mismo y loguearte con tus datos.`,
    devicesHelpManage: `Si quer\u00e9s eliminar un dispositivo, ingres\u00e1 a la aplicaci\u00f3n de ${brandName} y administralo desde la secci\u00f3n de perfil y configuraci\u00f3n.`,
    termsHelpPrefix: `Para ver los T\u00e9rminos y Condiciones de ${brandName} pod\u00e9s ingresar al sitio oficial haciendo`,
  };
}

export function defineBrandConfig(input: BrandConfigInput): BrandConfig {
  return {
    appName: 'TelePagos',
    ...input,
    links: {
      ...defaultLinks,
      ...input.links,
      website: input.links?.website ?? defaultWebsite,
    },
    assets: {
      ...defaultAssets,
      ...input.assets,
    },
  };
}
